<template>
  <div class="role">
    <el-dialog
      title="创建角色"
      :visible.sync="addflag"
      width="800"
      :before-close="closefn"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item class="btm" label="角色名称">
          <el-input
            placeholder="请输入角色名称"
            v-model.trim="form.username"
            width="200"
            maxlength="20"
          >
          </el-input>
        </el-form-item>
        <table class="roleTable" cellspacing="1" padding="10">
          <tr v-for="(roleP, idx) in roleList" :key="idx">
            <td class="roleLeft">
              <el-checkbox @change="rolePfn(idx)" v-model="roleP.isSelect">
                {{ roleP.Name }}
              </el-checkbox>
            </td>
            <td>
              <el-row>
                <el-col
                  :span="6"
                  v-for="roleC in roleP.children"
                  :key="roleC.Name + idx"
                >
                  <el-checkbox @change="roleCfn(idx)" v-model="roleC.isSelect">
                    {{ roleC.Name }}
                  </el-checkbox>
                  <div></div>
                </el-col>
              </el-row>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="right" type="primary " @click="addRolefn" plain
          >创建</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="编辑角色"
      :visible.sync="editflag"
      width="800"
      :before-close="closefn"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item class="btm" label="角色名称">
          <el-input
            placeholder="请输入角色名称"
            v-model.trim="form.username"
            width="200"
            maxlength="20"
          >
          </el-input>
        </el-form-item>
        <table class="roleTable" cellspacing="1" padding="10">
          <tr v-for="(roleP, idx) in roleList" :key="idx">
            <td class="roleLeft">
              <el-checkbox @change="rolePfn(idx)" v-model="roleP.isSelect">
                {{ roleP.Name }}
              </el-checkbox>
            </td>
            <td>
              <el-row>
                <el-col
                  :span="6"
                  v-for="roleC in roleP.children"
                  :key="roleC.Name + idx"
                >
                  <el-checkbox @change="roleCfn(idx)" v-model="roleC.isSelect">
                    {{ roleC.Name }}
                  </el-checkbox>
                  <div></div>
                </el-col>
              </el-row>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span @click="remRolefn" v-if="delFlag" class="red">删除角色</span>
        <el-button class="right" type="primary " @click="editRolefn" plain
          >保存</el-button
        >
      </span>
    </el-dialog>
    <el-row :gutter="20" class="searchRow">
        <el-col :span="22">
          <!-- 查询框区域 -->
          <el-form
            :model="searchForm"
            size="mini"
            :inline="true"
            label-width="90px"
          >
            <el-form-item label="角色名称">
              <el-input
                clearable
                size="mini"
                v-model="searchForm.name"
                placeholder="请输入"
                style="width: 12vw"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <!-- 提交按钮 -->
        <el-col :span="2" class="searchbuttons">
          <div>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              @click="filterData"
              >查询</el-button
            >
          </div>
          <div class="searchButton">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-refresh-right"
              @click="reset"
              >重置</el-button
            >
          </div>
        </el-col>
      </el-row>
        <div class="button-group">
          <el-button type="primary " size="small" v-if="addRoleFlag" @click="addfn"
            >创建角色</el-button
          >
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          :border="true"
          style="width: 100%"
        >
          <el-table-column align="center" type="index" label="序号" width="180">
          </el-table-column>
          <el-table-column align="center" prop="Name" label="角色名称">
          </el-table-column>
          <el-table-column align="center" prop="Count" label="成员数">
          </el-table-column>
          <el-table-column align="center" prop="CreateTime" label="创建日期">
          </el-table-column>
          <el-table-column
            v-if="editRoleFlag"
            align="center"
            fixed="right"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button :disabled="scope.row.Name=='超级管理员'" @click="editfn(scope.row)" type="text" size="small">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          @current-change="changefn"
          :page-size="size"
          :current-page="page"
        >
        </el-pagination>
    
  </div>
</template>

<script>
import {
  requestUserRoleList,
  requestUserPermissionList,
  userAddRole,
  userEditRole,
  requestUserRemoveRole,
  requestUserListRolePermissions
} from "@/api/userApi";

export default {
  name: "role",
  data() {
    return {
      loading: false,
      activeId: null,
      flag: true,
      total: 10,
      size: 10,
      page: 1,
      searchForm:{
        name: '',
      },
      addflag: false,
      editflag: false,
      form: {
        username: "",
      },
      roleList: [],
      tableData: [],
    };
  },
  created() {
  
    this.init();
  },
  computed: {
    permissions() {
      var p = [];
      this.roleList.forEach((item) => {
        item.children.forEach((el) => {
          if (el.isSelect) {
            p.push(el.Id);
          }
        });
      });
      return p;
    },
   
    //创建角色权限控制
    addRoleFlag() {
      return (
        this.$store.state.userInfo.permissions.includes("addRole") ||
        this.$store.getters.isAdmin
      );
    },
    //编辑角色权限控制
    editRoleFlag() {
      return (
        this.$store.state.userInfo.permissions.includes("updateRole") ||
        this.$store.getters.isAdmin
      );
    },
    //删除角色权限控制
    delFlag(){
      return  (
        this.$store.state.userInfo.permissions.includes("deleteRole") ||
        this.$store.getters.isAdmin
      );

    },
  },
  watch: {},
  methods: {
    init() {
      // this.requestUserRoleListfn();
      // this.requestUserPermissionListfn();
    },
    async requestUserPermissionListfn() {
      var res = await requestUserPermissionList();
      var p = res.data.data.result.tags;
      var c = res.data.data.result.permission;

      var arr = p.map((item) => {
        item.children = [];
        for (var i = 0; i < c.length; i++) {
          if (c[i].TagId == item.Id) {
            item.children.push(c[i]);
          }
        }

        return item;
      });
      var permissions = this.$store.state.userInfo.permissions;
      var permissionsflag = permissions.length == 0 ? true : false;
      for (var i = 0; i < arr.length; i++) {
        arr[i].isSelect = false; //为所有权限添加多选标识
        for (var j = 0; j < arr[i].children.length; j++) {
          arr[i].children[j].isSelect = false;
          if (
            !permissions.includes(arr[i].children[j].Front) &&
            !permissionsflag
          ) {
            arr[i].children.splice(j, 1); //只能操作当前用户拥有的权限，剔除个人拥有权限外的权限
            j--;
          }
        }
        if (arr[i].children.length == 0) {
          arr.splice(i, 1);
          i--;
        }
      }
      this.roleList = arr;
    },

    async requestUserRoleListfn() {
      this.loading = true;
      var res = await requestUserRoleList({
        page: this.page,
        size: this.size,
      });

      this.tableData = res.data.data.result.list;
      this.total = res.data.data.result.count;
      this.loading = false;
    },
   async editfn(row) {
      this.activeId = row.Id;
      this.activeName = row.Name;
      this.form.username = row.Name;
      this.editflag = true;
    var res =await requestUserListRolePermissions({
      id:row.Id
    })     

    res.data.data.result.rolePermission.forEach((item,index)=>{
      this.roleList.forEach((itm,i)=>{

        itm.children.forEach((t,j)=>{
            if(item.Id==t.Id){
             this.roleList[i].children[j].isSelect=true
          }

        })
      this.roleCfn(i)
        
      })
    })
    },
    addfn() {
      this.addflag = true;
    },
    remRolefn() {
      this.$confirm("确定删除该角色吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async() => {
          var count = this.tableData.find((item) => {
            return item.Id == this.activeId;
          }).Count;
          if (count > 0) {
            this.$alert("该角色包含成员，不可删除。", "删除失败", {
              confirmButtonText: "知道了",
              type: "error",
            });
          }else{
            var res = await requestUserRemoveRole({
              id:this.activeId
            })
            if(res.data.code==1000){
              this.$message({
                message:"删除成功",
                type:"success"
              })
            }else{
              this.$message({
                message:res.data.msg,
                type:"error"
              })
              
            }
            this.closefn();
            this.init()
          }
          // if(this.activeId)
        })
        .catch(() => {
          this.$message("已取消");
        });
    },
    async editRolefn() {
      if (this.form.username == "") {
        this.$message({
          type: "error",
          message: "角色姓名不能为空",
        });
      } else {
        var res = await userEditRole({
          id: this.activeId,
          name: this.form.username,
          permissions:this.permissions
        });
        if(res.data.code==1000){
          this.$message({
            message:"保存成功",
            type:"success"
          })
        }else{
          this.$message({
            message:res.data.msg,
            type:"error"
          })

        }
        this.closefn();
        this.init();
        
      }
    },
    async addRolefn() {
      if (this.form.username == "") {
        this.$message({
          type: "error",
          message: "角色姓名不能为空",
        });
      } else {
         console.log(this.permissions);
        var res = await userAddRole({
          name: this.form.username,
          permissions:this.permissions
        });
        if (res.data.code != 1000) {
          this.$alert(res.data.msg, "创建失败", {
            confirmButtonText: "知道了",
            type: "error",
          });
        } else {
          this.closefn();
          this.init();
          this.$message({
            message: "创建成功",
            type: "success",
          });
        }
      }
    },
    changefn(index) {
      this.page = index;
      this.requestUserRoleListfn();
    },
    closefn() {
      this.addflag = false;
      this.editflag = false;
      this.roleList.forEach((item, index) => {
        this.roleList[index].isSelect = false;
        item.children.forEach((itm, idx) => {
          this.roleList[index].children[idx].isSelect = false;
        });
      });
      this.form.username = "";
    },
    rolePfn(idx) {
      this.roleList[idx].children.forEach((item, index) => {
        this.roleList[idx].children[index].isSelect =
          this.roleList[idx].isSelect;
      });
    },
    roleCfn(pIndex) {
      this.roleList[pIndex].isSelect = this.roleList[pIndex].children.every(
        (item) => {
          return item.isSelect;
        }
      );
    },
    // 查询
   async filterData(){
      const {data} = await requestUserRoleList({
        ...this.searchForm,
        page: this.page,
        size: this.size,
      });
      if(data.code === 1000){
        this.tableData = data.data.result.list;
      this.total = data.data.result.count;
      }
    },
    reset(){
      this.searchForm.name = ""
    }
  },
};
</script>

<style lang="less">
.role {
  position: relative;
  width: 100%;
  padding: 15px;
  background-color: #fff;
  box-sizing: border-box;
  .button-group {
    width: 100%;
    // text-align: right;
    padding-bottom: 20px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .roleTable {
    font-size: 12px;
    background-color: #eee;
    td {
      background-color: #fff;
      padding: 10px;
      .el-checkbox {
        padding: 10px;
      }
    }
    .roleLeft {
      width: 20%;
    }
  }
  .fd {
    display: flex;
    justify-content: space-between;
    padding: 0 10px 10px;
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid #bbb;
    padding: 10px 15px;
  }
  .pdr {
    padding-right: 20px;
  }
  .el-form {
    padding: 10px;
    // border-bottom: 1px solid #bbb;
    margin-bottom: 20px;
    .btm {
      // border-bottom: 1px solid #bbb;
      padding-bottom: 10px;
    }
  }
  input {
    max-width: 200px;
  }

  .red {
    color: red;
    cursor: pointer;
    float: left;
    line-height: 2em;
  }
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
    thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>